// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8389e7ac","453":"9dd1270d"}[chunkId] + ".chunk.js";
};